import React, { Component } from 'react';
import { Layout, Row, Col, Menu, Icon } from 'antd';
import { NavLink, withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import './layout.css';
import moment from 'moment';
const { Footer } = Layout;


class SAFFooter extends Component {

    constructor(props) {
        super(props)
        this.logout = this.logout.bind(this);
    }

    logout = () => {
        this.props.actions.logout()
    }

    componentDidMount = () => {
        //this.props.actions.getProfileInfo()
    }

    render() {
        return (
            <div className='nesa-footer'>
                <Footer>
                    <ul className='social-link'>
                        <li className="cursor"><a target="_blank" href="https://www.facebook.com/ScoutingAlumniFriends/"><i className="fa fa-facebook fa-2x" aria-hidden="true"></i></a></li>
                        <li className="cursor"><a target="_blank" href="https://www.instagram.com/scoutingalumniofficial/"><i className="fa fa-instagram fa-2x" aria-hidden="true"></i></a></li>
                        {/* <li className="cursor"><a target="_blank" href="https://twitter.com/bsaalumni"><i className="fa fa-twitter fa-2x" aria-hidden="true"></i></a></li>
                        <li className="cursor"><a target="_blank" href="https://www.youtube.com/channel/UCUaCKENyhRuuw9gdHnstQHA"><i className="fa fa-google-plus fa-2x" aria-hidden="true"></i></a></li> */}
                    </ul>
                    <span>© {moment().format('YYYY')} Scouting Alumni – All Rights Reserved</span>


                    <ul>
                        <li className="cursor"><a target="_blank" href="https://scoutingalumni.org/resources/faq/">FAQ’s</a></li>
                        <li className="cursor"><a target="_blank" href="https://scoutingalumni.org/for-councils/training/"> Training </a></li>
                    </ul>

                </Footer>
            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        logout: state.authenticationReducer.logout,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(SAFFooter);




// WEBPACK FOOTER //
// ./src/components/Inc/SAFFooter.js